import { FillingExperienceContextProps } from '../../../provider/filling-experience.context';

export type SubmissionConfirmationMode = 'kiosk' | 'preview' | undefined;

type ModeInput = Pick<FillingExperienceContextProps, 'experienceType'> & {
  isPreviewMode?: boolean;
  isKioskOrigin?: boolean;
};

/**
 * Pure policy function — no hooks, no side-effects.
 *
 * Priority:
 *  1. 'kiosk'   — experienceType==='kiosk'  OR  public + isKioskOrigin
 *  2. 'preview' — public + isPreviewMode
 *  3. undefined — solicited or plain public  (→ Download + countdown)
 */
export function deriveSubmissionConfirmationMode({
  experienceType,
  isPreviewMode,
  isKioskOrigin,
}: ModeInput): SubmissionConfirmationMode {
  if (experienceType === 'kiosk' || isKioskOrigin) {
    return 'kiosk';
  }

  if (experienceType === 'public' && isPreviewMode) {
    return 'preview';
  }

  return undefined;
}
